import api from '../../utils/apiFetch';

const path = 'enterprise';
export default {
  getBusinesses: () => api.get(`${path}/info`),
  fetchBusiness: (id) => api.get(`merchants/${id}`),
  fetchBusinessByDomain: (domain) => api.get(`merchants/subdomain/${domain}`),
  getGiftCardConfig: (id) => api.get(`catalog/${id}`),
};
